import {Observable, of} from "rxjs";
import {PartialRecord} from "../../records/entities/partial-record.class";

export abstract class ShAbstractRecordDownloadService {
    abstract getDownloadUrlForAccessRepresentation(record: PartialRecord): Observable<string | null>;
}
